import actions from "../../actions";

const initialState = {
  isOpen: false,
  data: {
    suspended_by: 3, // change number to 2 after fix suspend modal bug
    id: 0,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.dashboard.suspendModal.SET_SUSPEND_MODAL_OPEN:
      return {
        isOpen: action.payload.state,
        data: state.data,
      };
    case actions.dashboard.suspendModal.SET_SUSPEND_MODAL_DATA:
      return {
        isOpen: state.isOpen,
        data: {
          ...state.data,
          ...action.payload.data,
        },
      };
    case actions.dashboard.suspendModal.RESET_SUSPEND_MODAL:
      return initialState;
    default:
      return state;
  }
};
